import React, { useState } from "react";
import "./Contact.css";
import { useNavigate, Link } from "react-router-dom";

function Contact() {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({ type: "", message: "" });
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // basic required check
    if (!formData.name || !formData.phone || !formData.message) {
      setStatus({
        type: "error",
        message: "Please fill all required fields (Name, Phone, Message).",
      });
      return;
    }

    if (!acceptedTerms) {
      setStatus({
        type: "error",
        message: "Please accept the terms and conditions to proceed.",
      });
      return;
    }

    // TODO: integrate with your API / email service here
    // Example: await axios.post("/api/contact", formData);

    setStatus({
      type: "success",
      message:
        "Thank you for contacting VaahanBuddy. We will get back to you soon.",
    });

    // Optionally clear form
    setFormData({
      name: "",
      phone: "",
      email: "",
      subject: "",
      message: "",
    });
    setAcceptedTerms(false);
  };

  return (
    <div className="contact-container">
      <div className="contact-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <span className="back-arrow">←</span> Back
        </button>
        {/* Updated h1 with app name */}
        <h1>VaahanBuddy - Contact Us</h1>
      </div>

      <div className="contact-content">
        <section className="contact-info-section">
          <h2>Get in Touch</h2>
          <p>
            Have a question about VaahanBuddy, vehicle services, or partnership
            opportunities? Use the form to reach us or contact using the details
            below.
          </p>
          <ul className="contact-list">
            <li style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ fontSize: "1.2rem" }}>📧</span>
              <strong>Email:</strong>
              <a href="mailto:hello@vaahanbuddy.com">
                hello@vaahanbuddy.com
              </a>
            </li>
            <li>
              <strong>📞 Phone:</strong> +91 97921 15599
            </li>
            <li>
              <strong>🏢 Address:</strong> Shop No - 42 First Floor, GDA
              Commercial Complex, Buddha Vihar Part-A, Taramandal Gorakhpur,
              U.P. - 273016
            </li>
          </ul>
        </section>

        <section className="contact-form-section">
          <h2>Send a Message</h2>
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <label htmlFor="name">
                Name<span className="required">*</span>
              </label>
              <input
                id="name"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your full name"
              />
            </div>

            <div className="form-row">
              <label htmlFor="phone">
                Phone<span className="required">*</span>
              </label>
              <input
                id="phone"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter your phone number"
              />
            </div>

            <div className="form-row">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email (optional)"
              />
            </div>

            <div className="form-row">
              <label htmlFor="subject">Subject</label>
              <input
                id="subject"
                name="subject"
                type="text"
                value={formData.subject}
                onChange={handleChange}
                placeholder="How can we help you?"
              />
            </div>

            <div className="form-row">
              <label htmlFor="message">
                Message<span className="required">*</span>
              </label>
              <textarea
                id="message"
                name="message"
                rows="4"
                value={formData.message}
                onChange={handleChange}
                placeholder="Write your message here"
              />
            </div>

            {status.message && (
              <div
                className={
                  status.type === "success"
                    ? "form-status success"
                    : "form-status error"
                }
              >
                {status.message}
              </div>
            )}

            <div className="form-row checkbox-row" style={{ marginTop: '15px', marginBottom: '20px' }}>
              <label className="checkbox-label" style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', fontSize: '0.9rem', color: '#555', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={acceptedTerms}
                  onChange={(e) => setAcceptedTerms(e.target.checked)}
                  style={{ marginTop: '4px', width: 'auto' }}
                  required
                />
                <span>
                  I hereby accept the <Link to="/terms-conditions" style={{color: 'var(--color-primary)', textDecoration: 'none'}}>terms and conditions</Link> and consent to receive communications from <strong>Raisclab Advisory LLP</strong> and its partners through SMS, Email, RCS, and WhatsApp.
                </span>
              </label>
            </div>

            <button type="submit" className="submit-button">
              Send Message
            </button>
          </form>
        </section>
      </div>
    </div>
  );
}

export default Contact;
